/* @jsx h */
import { useLocalization } from "@lemmonhq/uikit";
import { defineComponent, h, ref } from "vue";

// Shown in plain text by default: printer and Wi-Fi passwords are typed
// once during setup, usually off a sticker, so typos matter more than
// someone looking over the shoulder.
export const PasswordField = defineComponent<{
  value: string;
  disabled?: boolean;
  placeholder?: string;
  onInput: (value: string) => void;
}>({
  name: "PrinterSetupPasswordField",
  props: ["value", "disabled", "placeholder", "onInput"],
  setup(props) {
    const { t } = useLocalization();
    const isVisible = ref(true);

    return () => (
      <div class="relative w-full">
        <input
          type={isVisible.value ? "text" : "password"}
          autocomplete="off"
          autocapitalize="off"
          spellcheck={false}
          class="input input-bordered h-10 min-h-10 w-full pr-12"
          placeholder={props.placeholder}
          value={props.value}
          disabled={props.disabled}
          onInput={(event: Event) =>
            props.onInput((event.target as HTMLInputElement).value)
          }
        />
        <button
          type="button"
          class="btn btn-ghost btn-sm btn-square absolute right-2 top-1/2 -translate-y-1/2"
          aria-label={
            isVisible.value
              ? t("devices.bt_printer.hide_password")
              : t("devices.bt_printer.show_password")
          }
          onClick={() => (isVisible.value = !isVisible.value)}
        >
          <span class="material-symbols-outlined text-xl">
            {isVisible.value ? "visibility_off" : "visibility"}
          </span>
        </button>
      </div>
    );
  },
});
